import type { City } from '../models/city.js';
import type { ROMEJob } from '../models/rome-job.js';
import type { UserWishedJob } from '../models/user-wished-job.js';
import type { UserZoneOfSearch } from '../models/user-zone-of-search.js';
import { User, UserOrigin } from '@addviseo/shared/types';

export interface BeneficiarySearchCriteriaResponse {
  wishedJobs: (UserWishedJob & { romeJob?: Partial<ROMEJob> })[];
  wishedContractType: string[] | null;
  zoneOfSearch:
    | (UserZoneOfSearch & {
        city?: Pick<City, 'inseeCode' | 'name' | 'zipCodes'>;
      })
    | null;
}

export interface CreateOrganizationInput {
  sieId: string;
  name: string;
}

export interface CreateAgencyInput {
  sieId: string;
  name: string;
}

export interface CreateBeneficiaryInput {
  sieId: string;
  ide: string;
  lastName: string;
  firstName: string;
  programTitle: string;
  orderLetter: string | null;
  phoneNumber: string | null;
  email: string | null;
  firstAppointmentTime: string | null;
  firstAppointmentDate: Date | null;
  firstAppointmentModality: UserAppointmentModality | null;
  firstAppointmentAddress: string | null;
  firstAppointmentAddress2?: string | null;
  firstAppointmentZipCode: string | null;
  firstAppointmentCity: string | null;
  marketCode: string | null;
  organization: CreateOrganizationInput;
  agency: CreateAgencyInput;
  origin: UserOrigin;
  externalId?: string | null;
}

export enum UserAppointmentModality {
  IN_PERSON = 'in_person',
  REMOTE = 'remote',
}

export interface GCUPayload {
  accepted: boolean;
}

export interface ValidateOnboardingStepPayload {
  step: User['onboardingStep'];
}

export interface SetPasswordPayload {
  password: string;
}

export interface UserZoneOfSearchPayload {
  nationalMobility: boolean;
  cityInsee?: string | null;
  distance?: number | null;
  internationalMobility: boolean;
}

export interface UpdateBeneficiaryInput {
  sieId: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  phoneNumber?: string | null;
  zipCode?: string;
  cityName?: string;
  externalId?: string | null;
}

export interface UpdateBeneficiaryResponse {
  id: number;
  sieId: string;
  firstName: string;
  lastName: string;
  email: string;
  previousEmail?: string | null;
  phoneNumber: string | null;
  zipCode: string | null;
  cityName: string | null;
  externalId?: string | null;
}

export interface UpdateBeneficiaryProgramInput {
  sieId: string;
  addviseoUserId?: number | null;
  addviseoProgramId?: number | null;
  startedAt?: Date | null;
  endedAt?: Date | null;
  theoreticalEndDate?: Date | null;
  accessUntil?: Date | null;
  advisorId?: number | null;
}
